import { FC } from "react";
import { StructuredText } from "react-datocms";
import classNames from "classnames";
import { createColorClass } from "utils";
import { HighlightedTextRecord } from "@graphql/types/graphql";
import { IColor } from "@types";
import s from "./HighlightedText.module.scss";

export const HighlightedText: FC<HighlightedTextRecord> = ({ text, color }) => {
  if (text)
    return (
      <div className={classNames(s.Container, createColorClass(color as IColor, s))}>
        <StructuredText data={text as any} />
      </div>
    );

  return null;
};
